export default __webpack_public_path__ + "assets/366c192517682a90abcbacfe7aa15c84.jpg";